import {
  AfterContentInit,
  Component,
  HostBinding,
  HostListener,
  Inject,
  Injector,
  Input, OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { CurrenciesContainer, Currency, LandingModel } from 'projects/common/model/landingModel';
import { OfferCardData, OfferCardSubtype, OfferCardType, OfferModule, ViewMode } from '../offer-card-data.model';
import { TextPosition } from 'projects/common/model/ModuleModel';
import { ScreenType } from 'projects/common/model/ScreenType';
import { MainTitle } from 'projects/common/components/main-title/main-title.component';
import { AbstractComponent } from '../../abstract.component';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { LoyaltyMode, LoyaltyService } from '@shopping-angular-components/loyalty';
import { SliderProOptions } from '../../slider-pro/slider-pro.component';
import { OfferCardSelectorComponent } from '../offer-card-selector/offer-card-selector.component';
import { TitleCardComponent } from '../title-card/title-card.component';
import { OffersButtonItemComponent } from './offers-button-item.component';
import { UtilsService } from 'projects/common/services/utils.service';

declare var document: any;
declare var upaData: any;

@Component({
  selector: 'offers',
  template: `
    <div #sliderContainer class="offer-module-container" [ngClass]="{'BANNER': this.isBannerView, '-ssr': this.isPlatformServer}">
        <div *ngIf="showMainTitle()" class="offer-title-wrapper" [ngClass]="{'-with-logo': module.logo && module.logo.src, '-margin-bottom': hasTitle, '-margin-list': isListModule, '-grid-title': module.grid_mode}">
        <img *ngIf="showMainTitle() && module.logo && mediaPictureService.getMediaUrl(module.logo.src) as src" class="logo" [src]="src" loading="lazy" alt="logo"/>
        <main-title *ngIf="showMainTitle()" [data]="mainTitleData" class="title-container top" [moduleId]="module.id" [uniqueId]="module.unique_id" defaultColor="var(--color-neutral-800)" [showMoreTextMobile]="true"></main-title>
      </div>
      <!-- No Slider / Desktop -->
      <ng-container *ngIf="!showSlider">
        <div class="offer-cards-container offers-first-row"
             [ngClass]="{'offer-cards-container-highlighted': module.offer_view_type === 'HIGHLIGHTED', 'grid-row': module.grid_mode, 'REDUCED': isOfferCardTypeReduced(), 'offers-vertical-list': isListModule}">
          <ng-container *ngIf="module.data">
            <ng-container *ngFor="let offerData of module.data; let i = index">
              <offer-card-selector *ngIf="i <= lastVisibleIndex" [data]="offerData" [currency]="resolveCurrency(offerData)"
                        [moduleId]="module.id" [uniqueId]="module.unique_id || 'empty'" [moduleIndex]="module.row_number" [loyaltyMode]="loyaltyService.mode$ | async"
                        [positionIndex]="i" [offerViewType]="module.offer_view_type" [detailOffer]="module.detail_offer" [rankedItems]="module.ranked_items"
                        [locale]="locale" [flow]="flow" [offerCardType]="this.getOfferCardType(offerData)" [offerCardSubtype]="this.getOfferCardSubtype(offerData)"
                        [moduleReferer]="moduleReferer"
                        [sboxAutocomplete]="module.sbox_autocomplete"
                        [isLast]="i === lastVisibleIndex"></offer-card-selector>
            </ng-container>
          </ng-container>
        </div>

        <div class="see-more-offers" *ngIf="module.data && (module.data.length - 1) > lastVisibleIndex && !allRowVisible">
          <eva-button [options]="{ghost_button: true, type: '-default', size: '-md', link_text: ('offers.buttons.seeMoreOffers.' + !otherRowsVisible) | translate}"
                      (clickEvent)="onSeeMoreOffersClick()" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></eva-button>
        </div>
      </ng-container>
      <!-- End desktop -->
      <!-- Slider -->
      <div class="offer-slider-row {{sliderClasses}}" *ngIf="showSlider">
        <div class="side-text title-wrapper {{module.text_vertical_align}}" [ngClass]="{'-with-logo': module.logo}" *ngIf="showSideTitle()">
          <img *ngIf="module.logo && mediaPictureService.getMediaUrl(module.logo.src) as src" class="logo" [src]="src" loading="lazy" alt="logo"/>
          <main-title [data]="mainTitleData" class="title-container side" [moduleId]="module.id" [uniqueId]="module.unique_id" defaultColor="var(--color-neutral-800)"></main-title>
          <eva-button *ngIf="module.button" class="-eva-3-mt-xxlg"
                      [newTab]="true"
                      [options]="{type: '-default', ghost_button: true, size: '-md', link_text: module.button.link_text, link: module.button.link, next: true}"
                      [moduleId]="module.id"
                      [moduleIndex]="module.row_number"
                      [uniqueId]="module.unique_id">
          </eva-button>
        </div>

        <slider-pro
          [options]="sliderProOptions"
          [componentParams]="componentParams"
          [components]="components"
          [upaData]="upaData"
          (initialized)="onResize()">
        </slider-pro>

      <!-- End slider -->
    </div>
  `,
  styleUrls: ['./offers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OffersComponent extends AbstractComponent implements OnInit, AfterContentInit, OnChanges {
  @Input() override module: OfferModule;
  @Input() currency: Currency;
  @Input() allRowVisible: boolean;

  @ViewChild('sliderContainer', { read: ViewContainerRef, static: true }) sliderContainer: ViewContainerRef;

  textPosition: TextPosition;
  otherRowsVisible = false;
  showSlider = false;

  mainTitleData: MainTitle;
  hasTitle: boolean;
  locale: string;

  sliderClasses: string;
  isBannerView = false;
  isPlatformServer = false;
  isDestinationExplorer = false;
  currencies: CurrenciesContainer;
  loyaltyMode: LoyaltyMode | null = null;

  @HostBinding('style.--itemsPerRow') itemsPerRow = 4;
  @HostBinding('style.--margin-offer-module') marginOfferModule: string;

  componentParams: any[] = [];
  components: Type<any>[] = [];
  sliderProOptions: SliderProOptions;
  upaData: any;
  landingModel: LandingModel;
  isListModule = false;
  lastVisibleIndex = 0;
  moduleReferer?: string;

  constructor(
    injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string,
    public mediaPictureService: MediaPictureService,
    public loyaltyService: LoyaltyService
  ) {
    super(injector);
    this.landingModel = this.landingModelService.getLandingModel();
    this.currencies = this.landingModel.currencies;
  }

  ngOnInit() {
    this.loyaltyService.mode$.subscribe(newMode => {
      if (newMode != this.loyaltyMode) {
        this.loyaltyMode = newMode
        this.init();
      }
    });
    this.init();
  }

  init(): void {
    this.upaData = {
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      uniqueId: this.module.unique_id
    };

    this.moduleReferer = this.module?.referer_name;

    this.locale = this.landingModel.language + '_' + this.landingModel.country;
    this.textPosition = this.module.text_position ? this.module.text_position : TextPosition.TOP;
    this.mainTitleData = {
      title: this.module.title,
      pre_title: this.module.pretitle,
      sub_title: this.module.subtitle,
      more_text: this.module.more_text,
      tip_message: this.module.tip_message,
      card_link: this.module.button?.link,
      card_image: this.module.logo?.src ? {
        src: this.module.logo.src,
        alt: this.module.title?.text || ''
      } : undefined,
      title_card_variant: this.module.title_card_variant
    };

    this.hasTitle = UtilsService.hasAnyValue(this.mainTitleData);

    this.isBannerView = this.module.view_mode === ViewMode.BANNER;
    this.isPlatformServer = isPlatformServer(this.platformId);
    
    // TODO borrar cuando se refactorice la configuracion de grid/slider por modulo y dispositivo
    const isJetskyCUN = isPlatformBrowser(this.platformId) && typeof upaData !== 'undefined' && upaData?.lname == 'jetski-prueba-Cun-MX' && this.screenType !== ScreenType.DESKTOP;
    this.isListModule = this.isListOnlyModule();
    // cuando muestra el slider el title se renderiza desde otro lugar
    this.showSlider = !this.isListModule && !isJetskyCUN && (this.module.slider_mode || (!this.module.grid_mode 
        && (this.textPosition.includes('SIDE')
            || this.textPosition === TextPosition.CARD
            || this.screenType !== ScreenType.DESKTOP))
          || (this.isBannerView && this.module.data && this.module.data.length > 3)
        );

    if (!this.isBannerView && this.showSlider) this.marginOfferModule = '0 -16px';

    this.isDestinationExplorer = this.isSimplifiedDestinationExplorer();
    this.calculateItemsPerRow();
    this.transformModelToSliderPro();
    this.initSliderProOptions();

    this.sliderClasses = this.showSideTitle() ? this.getHorizontalOrder() : '';
    this.setLastVisibleIndex();
  }

  private calculateItemsPerRow() {
    if (isPlatformBrowser(this.platformId)) {
      const innerWidth = window.innerWidth;

      if (this.isDestinationExplorer) {
        this.itemsPerRow = this.calculateItemsPerRowDestinationExplorerAccess(innerWidth);
      }
      else if (this.showSlider) {
        if (this.screenType == 'MOBILE') {
          this.itemsPerRow = 1.3;
        } else {
          if (innerWidth >= 768 && innerWidth <= 1279) {
            this.itemsPerRow = this.showSideTitle() ? 2 : 3;
          } else {
            this.itemsPerRow = this.showSideTitle() ? 3 : 4;
          }
        }

      } else {
        this.itemsPerRow = innerWidth < 768 ? 1 : innerWidth >= 768 && innerWidth <= 1279 ? 3 : 4;
      }
    } else {
      if (this.isDestinationExplorer) {
        this.itemsPerRow = this.screenType === 'MOBILE' ? 1 : 3;
      } else if (this.textPosition === TextPosition.TOP && this.screenType != 'MOBILE') {
        this.itemsPerRow = 4;
      } else {
        this.itemsPerRow = this.screenType == 'MOBILE' ? 1.3 : 3;
      }
    }
  }

  private calculateItemsPerRowDestinationExplorerAccess(innerWidth: number): number {
    if (innerWidth < 480) {
      return 2.1;
    }
    if (innerWidth < 768) {
      return 3.1;
    }
    if (innerWidth < 1024) {
      return 4.1;
    }
    if (innerWidth < 1280) {
      return 5.1;
    }
    return 6;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.module?.firstChange && (changes?.module?.currentValue != null || changes?.currency?.currentValue != null)) {
      this.ngOnInit();
    }
  }

  ngAfterContentInit() {
    this.onResize();
  }

  @HostListener('window:resize')
  onResize() {
    if (this.landingModelService.getLandingModel().distributionId === 'dynamicIframe') {
      setTimeout(() => {
        if (this.sliderContainer.element.nativeElement) {
          window.top?.postMessage({
            landingIframe: {
              height: this.sliderContainer.element.nativeElement.closest('.eva-3-container.module-RecommendedOffersModule').offsetHeight
            }
          }, '*');
          document.querySelector("body").style['overflow'] = 'hidden';
        }
      }, 500);
    }
  }

  initSliderProOptions() {
    this.sliderProOptions = {
      itemsToShow: { 'DEFAULT': this.itemsPerRow },
      itemsToMove: { 'DEFAULT': 1 },
      fixedWidth: { 'DEFAULT': this.getFixedWidth() },
      dragToMove: { 'DEFAULT': this.screenType != 'DESKTOP' },
      showArrows: { 'DEFAULT': this.screenType == 'DESKTOP' },
      showDots: { 'DEFAULT': !this.isDestinationExplorer },
      dotsLighten: false,
      arrowsInnerContainer: this.isBannerView
    };
  }

  transformModelToSliderPro() {
    this.components = [];
    this.componentParams = [];

    if (this.showCardTitle()) {
      this.components.push(TitleCardComponent);
      this.componentParams.push({ 
        data: this.mainTitleData,
        module: this.module,
        moduleIndex: this.module.row_number
      });
    }

    // Verificar que module.data existe antes de procesarlo
    if (this.module.data && this.module.data.length > 0) {
      this.components = [...this.components, ...new Array(this.module.data.length).fill(OfferCardSelectorComponent)];
      this.componentParams = [...this.componentParams, ...this.module.data.map((offer: OfferCardData, index: number) => {
        return {
          data: offer,
          currency: this.currency,
          moduleId: this.module.id,
          moduleIndex: this.module.row_number,
          uniqueId: this.module.unique_id,
          positionIndex: index,
          offerViewType: this.module.offer_view_type,
          detailOffer: this.module.detail_offer,
          rankedItems: this.module.ranked_items,
          moduleReferer: this.moduleReferer,
          locale: this.locale,
          loyaltyMode: this.loyaltyMode,
          flow: this.flow,
          offerCardType: this.getOfferCardType(offer),
          offerCardSubtype: this.getOfferCardSubtype(offer),
          sboxAutocomplete: this.module.sbox_autocomplete
        }
      })];
    }

    if (this.module.button && !this.showSideTitle()) {
      this.components.push(OffersButtonItemComponent);
      this.componentParams.push({
        module: this.module,
        moduleIndex: this.module.row_number,
        buttonVariant: this.mainTitleData?.title_card_variant
      });
    }
  }

  getModuleId(): string {
    return this.module.id;
  }

  getHorizontalOrder() {
    return `slider-row ${this.textPosition === TextPosition.SIDE_REVERSED ? 'reversed-row' : ''}`;
  }

  onSeeMoreOffersClick(): void {
    this.otherRowsVisible = !this.otherRowsVisible;
    this.setLastVisibleIndex();
  }

  showSideTitle(): boolean {
    return this.textPosition.includes('SIDE') && this.screenType === 'DESKTOP';
  }

  showCardTitle(): boolean {
    return this.textPosition === 'CARD';
  }

  showMainTitle(): boolean {
    return !this.showSideTitle() && !this.showCardTitle();
  }

  resolveCurrency(offerData: OfferCardData): Currency {
    const forceCurrencyCode = offerData.force_currency_code ? offerData.force_currency_code : this.module.force_currency_code

    if (forceCurrencyCode) {
      return this.getCurrencyByCode(forceCurrencyCode)!;
    }

    return this.currency;
  }

  getCurrencyByCode(code) {

    if (this.currencies.primaryCurrency.code === code) {
      return this.currencies.primaryCurrency;
    }

    if (this.currencies.secondaryCurrency?.code === code) {
      return this.currencies.secondaryCurrency;
    }

    return null;
  }

  isSimplifiedDestinationExplorer(): boolean {
    if (this.module.offer_card_type === OfferCardType.SIMPLIFIED &&
      this.module.offer_card_subtype === OfferCardSubtype.SIMPLIFIED_DESTINATION_EXPLORER) {
      return true;
    }
    return !!this.module.data?.some(offerData =>
      this.getOfferCardType(offerData) === OfferCardType.SIMPLIFIED &&
      this.getOfferCardSubtype(offerData) === OfferCardSubtype.SIMPLIFIED_DESTINATION_EXPLORER
    );
  }

  getOfferCardType(offerData: OfferCardData): OfferCardType {
    return offerData.offer_card_type || this.module.offer_card_type;
  }

  getOfferCardSubtype(offerData: OfferCardData): OfferCardSubtype | undefined {
    return offerData.offer_card_subtype || this.module.offer_card_subtype;
  }

  getFixedWidth(): number | undefined {
    const hasBasicOffer = this.module.data?.some(offerData => this.getOfferCardType(offerData) === OfferCardType.BASIC) || this.module.offer_card_type === OfferCardType.BASIC;
    
    if (this.isOfferCardTypeReduced() && !hasBasicOffer) {
      return 198;
    }

    if (this.isDestinationExplorer && !this.isPlatformServer) {
      return this.screenType === ScreenType.MOBILE ? 156 : 193;
    }

    return undefined;
  }

  isOfferCardTypeReduced(): boolean {
    return this.module.data?.some(offerData => this.getOfferCardType(offerData) === OfferCardType.REDUCED) || this.module.offer_card_type === OfferCardType.REDUCED;
  }

  private isListOnlyModule(): boolean {
    const data = this.module.data ?? [];
    if (data.length === 0) return false;

    return data.every(o => this.getOfferCardType(o) === OfferCardType.LIST);
  }

  private setLastVisibleIndex(): void {
    const visibleLimit = this.getVisibleLimit();
    this.lastVisibleIndex = visibleLimit - 1; // si visibleLimit=0 => -1 (no renderiza nada)
  }

  private getVisibleLimit(): number {
    const total = this.module?.data?.length ?? 0;

    if (total === 0) {
      return 0;
    }
    if (this.allRowVisible || this.otherRowsVisible || this.showSlider) {
      return total;
    }

    if (this.screenType === ScreenType.MOBILE) {
      const mobileVisibleItems = this.module.mobile_visible_items ?? 4;
      return Math.min(total, mobileVisibleItems);
    }

    const perRow = Math.max(1, Math.ceil(this.itemsPerRow));
    const rows = this.module.desktop_visible_rows ?? 1
    return Math.min(total, perRow * rows);
  }
}
